(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["site-settings-modal"] && !Shopify.designMode) return;
  try {
    (function () {
  const modal = document.getElementById('site-settings-modal');
  if (!modal) return;

  const marketDataEl = document.getElementById('site-settings-market-data');
  const marketData = marketDataEl ? JSON.parse(marketDataEl.textContent) : {};

  const countrySelect  = document.getElementById('site-settings-country');
  const langList       = document.getElementById('site-settings-lang-list');
  const taxInfo        = document.getElementById('site-settings-tax-info');
  const marketHeading  = document.getElementById('site-settings-market-heading');
  const flagImg        = document.getElementById('site-settings-flag');
  const ctaButton      = document.getElementById('site-settings-cta');

  function updateForCountry(iso) {
    const data = marketData[iso];
    if (!data) return;

    if (flagImg) {
      flagImg.src = data.flag_url;
      flagImg.alt = data.name;
    }

    if (marketHeading) {
      marketHeading.textContent = marketHeading.dataset.template.replace('__MARKET__', data.name);
    }

    if (taxInfo) {
      taxInfo.textContent = taxInfo.dataset.template.replace('__CURRENCY__', data.currency_name);
    }

    if (ctaButton) {
      ctaButton.textContent = ctaButton.dataset.template.replace('__MARKET__', data.name);
    }

    if (langList) {
      const currentLang = langList.querySelector('input:checked')?.value;
      const langAvailable = currentLang && data.languages.some(l => l.iso_code === currentLang);
      langList.innerHTML = data.languages.map((lang, i) => {
        const isChecked = langAvailable ? lang.iso_code === currentLang : i === 0;
        return `<label class="site-settings-modal__lang-option">
          <input type="radio" name="language_code" value="${lang.iso_code}"${isChecked ? ' checked' : ''}>
          <span>${lang.name}</span>
        </label>`;
      }).join('');
    }
  }

  if (countrySelect) {
    countrySelect.addEventListener('change', function () {
      updateForCountry(this.value);
    });
  }

  modal.querySelector('.site-settings-modal__close')?.addEventListener('click', () => modal.close());
  modal.addEventListener('click', e => { if (e.target === modal) modal.close(); });

  document.addEventListener('click', e => {
    if (e.target.closest('[data-open-site-settings]')) modal.showModal();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
